function slickSlider(){

    "use strict";

    var PRODCUT_SLIDER_VIEW = '.product-slider__view';

    $('.product-slider__view').slick({
        slidesToShow: 1,
        draggable: false,
        prevArrow: $('slick-prev'),
        nextArrow: $('slick-next')
    });

    $('li.product-slider__thumbnail[data-slide]').click(function(e) {
        e.preventDefault();
        var currentSlide = $( PRODCUT_SLIDER_VIEW ).slick('slickCurrentSlide');
        var slideIndex = $(this).data('slide');
        if (currentSlide != slideIndex) {
            $('.product-slider__view').slick('slickGoTo', slideIndex);
        }
    });
    $('.slick-next').click(function (e) {
        $( PRODCUT_SLIDER_VIEW ).slick('slickGoTo', ( $( PRODCUT_SLIDER_VIEW ).slick('slickCurrentSlide') + 1 ));
    });
    $('.slick-prev').click(function (e) {
        $( PRODCUT_SLIDER_VIEW ).slick('slickGoTo', ( $( PRODCUT_SLIDER_VIEW ).slick('slickCurrentSlide') - 1 ));
    });
}

module.exports = slickSlider;


// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/components/global/08_slider.js